export default {
    SUBMIT_IMPORTAR_CLIENTES_EXCEL: 'SUBMIT_IMPORTAR_CLIENTES_EXCEL',
    SUBMIT_IMPORTAR_CLIENTES_EXCEL_SUCCESS: 'SUBMIT_IMPORTAR_CLIENTES_EXCEL_SUCCESS',
    ABRIR_MODAL_IMPORTAR_CLIENTES_EXCEL: 'ABRIR_MODAL_IMPORTAR_CLIENTES_EXCEL',
    CERRAR_MODAL_IMPORTAR_CLIENTES_EXCEL: 'CERRAR_MODAL_IMPORTAR_CLIENTES_EXCEL',
    SUBIR_ARCHIVOS_IMPORTAR_CLIENTES_EXCEL: 'SUBIR_ARCHIVOS_IMPORTAR_CLIENTES_EXCEL',
    DESCARGAR_PLANTILLA_EXCEL_CLIENTES_EXCEL: 'DESCARGAR_PLANTILLA_EXCEL_CLIENTES_EXCEL',
    DESCARGAR_CLIENTES_EXCEL: 'DESCARGAR_CLIENTES_EXCEL'
  }